import {
    START_ONBOARDING,
    PREV_ONBOARDING,
    NEXT_ONBOARDING,
    WEBSITE_CUSTOM,
    UPDATE_PROJECT_NAME,
    UPDATE_WEBSITE_URL,
    REMOVE_CHANNEL_ONBOARDING,
    ADD_CHANNEL_ONBOARDING,
    SET_APPLICATION_CREATED,
    SET_WEBSITE_TYPE,
    WEBSITE_WORDPRESS
} from './constants'

import { SETUP_PROJECT, SETUP_CHANNELS, CHOOSE_PLUGIN, PLUGIN_CUSTOM, PLUGIN_WORDPRESS, CONGRATGS } from './steps'

const getPrevState = currentState => {
    switch (currentState) {
        case SETUP_PROJECT:
        case SETUP_CHANNELS:
            return SETUP_PROJECT
        case CHOOSE_PLUGIN:
        case PLUGIN_WORDPRESS:
        case PLUGIN_CUSTOM:
            return CHOOSE_PLUGIN
        case CONGRATGS:
            return CONGRATGS
        default:
            return null
    }
}

const getNextState = state => {
    switch (state.currentState) {
        case SETUP_PROJECT:
            return SETUP_CHANNELS
        case SETUP_CHANNELS:
            return CHOOSE_PLUGIN

        case CHOOSE_PLUGIN:
            switch (state.websiteType) {
                case WEBSITE_WORDPRESS:
                    return PLUGIN_WORDPRESS
                default:
                    return PLUGIN_CUSTOM
            }

        case PLUGIN_CUSTOM:
        case PLUGIN_WORDPRESS:
            return CONGRATGS

        default:
            return null
    }
}

const initialState = {
    currentState: SETUP_PROJECT,
    websiteUrl: null,
    projectName: null,
    channels: [{ name: 'General' }, { name: 'Support' }, { name: 'Random' }],

    applicationCreated: null,

    websiteType: null
}

const reducer = (state = initialState, { type, payload, error }) => {
    let channels = state.channels

    switch (type) {
        case START_ONBOARDING:
            return {
                ...state,
                currentState: SETUP_PROJECT
            }
        case PREV_ONBOARDING:
            return {
                ...state,
                currentState: getPrevState(state.currentState)
            }
        case NEXT_ONBOARDING:
            return {
                ...state,
                currentState: getNextState(state)
            }

        case UPDATE_PROJECT_NAME:
            return {
                ...state,
                projectName: payload
            }
        case UPDATE_WEBSITE_URL:
            return {
                ...state,
                websiteUrl: payload
            }

        case REMOVE_CHANNEL_ONBOARDING:
            const idx = state.channels.indexOf(payload.channel)
            if (idx > -1) {
                channels.splice(idx, 1)
            }
            return {
                ...state,
                channels: [...channels]
            }
        case ADD_CHANNEL_ONBOARDING:
            if (channels.length < 5) {
                channels.push(payload)
            }
            let uniqueChannels = Array.from(new Set(channels.map(JSON.stringify))).map(JSON.parse)

            return {
                ...state,
                channels: [...uniqueChannels]
            }

        case SET_APPLICATION_CREATED:
            return {
                ...state,
                applicationCreated: payload
            }

        case SET_WEBSITE_TYPE:
            return {
                ...state,
                websiteType: payload.websiteType
            }

        default:
            return state
    }
}

export default reducer
